import { useEffect, useMemo, useState } from "react";
import {
  EditButton,
  DeleteButton,
  Stack,
  CreateButton,
  Typography,
  useDataGrid,
  DataGrid,
  List,
  TextField,
  MenuItem,
} from "@pankod/refine-mui";
import { useSelect } from "@pankod/refine-core";
import { itIT } from "@mui/x-data-grid";
import useLocales from "locales/useLocales";
import useAuth from "contexts/AuthContext";

export default function CompList() {
  const [filterValue, setFilterValue] = useState(-1);
  const { currentLang, defaultLang } = useLocales();
  //const owner = JSON.parse(localStorage.getItem("user")).id;
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  let filter = [];
  if (auth.user.role.name != "admin")
    filter = [
      {
        field: "facility.owner.id",
        operator: "eq",
        value: owner,
      },
    ];

  const {
    dataGridProps,
    sortingMode,
    sortModel,
    onSortModelChange,
    setFilters,
  } = useDataGrid({
    metaData: {
      locale: defaultLang,
      populate: {
        localizations: true,
        facility: {
          fields: ["id", "businessName"],
        },
        accommodation_type: {
          fields: "name",
          populate: {
            localizations: {
              fields: ["name", "locale"],
            },
          },
        },
      },
      fakeParam: currentLang.value, //this is to force re-fetching data when language changes
    },
    permanentFilter: filter,
  });

  useEffect(() => {
    //show only those records where the correct localization exists
    if (dataGridProps.rows.length > 0) {
      //console.log(dataGridProps.rows);
      const localizedRows = [];
      dataGridProps.rows.forEach((row) => {
        let localizations = row.localizations;
        if (localizations) {
          let localeIDX = localizations.indexOf(
            (l) => l.locale == currentLang.value
          );
          if (localeIDX > -1) {
            localizedRows.push(row);
          }
        }
      });

      dataGridProps.rows = localizedRows;
    }
  }, [dataGridProps]);

  const columns = useMemo(
    () => [
      { field: "name", headerName: "Nome", flex: 1, minWidth: 200 },
      {
        field: "accommodation_type",
        headerName: "Tipologia",
        valueGetter: ({ row }) => {
          const value = row.accommodation_type?.name;
          return value;
        },
        flex: 1,
        minWidth: 150,
      },
      {
        field: "facility",
        headerName: "Struttura",
        valueGetter: ({ row }) => {
          const value = row.facility?.businessName;
          return value;
        },
        flex: 1,
        minWidth: 200,
      },
      {
        field: "maxGuests",
        headerName: "N max persone",
        flex: 1,
        minWidth: 50,
      },
      {
        field: "maxChildren",
        headerName: "N max bambini",
        flex: 1,
        minWidth: 50,
      },
      { field: "quantity", headerName: "Quantità", flex: 1, minWidth: 100 },
      {
        headerName: "Azioni",
        field: "actions",
        minWidth: 50,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton hideText recordItemId={params.row.id} />
              <DeleteButton hideText recordItemId={params.row.id} />
            </Stack>
          );
        },
      },
    ],
    []
  );

  const { options: facilityAC } = useSelect({
    resource: "strutture",
    optionLabel: "businessName",
    optionValue: "id",
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
  });
  const options = [{ value: -1, label: "Tutte" }, ...facilityAC];

  const handleFilter = (e) => {
    const selected = e.target.value;
    //console.log(e.target.value);
    //const match = options.map((item) => item.value).indexOf(e.target.value);
    if (selected >= 0)
      setFilters([
        {
          field: "facility.id",
          operator: "eq",
          value: selected,
        },
      ]);
    else {
      setFilters([]);
    }
    setFilterValue(selected);
  };

  return (
    <List
      resource="accommodations"
      headerButtons={<CreateButton>Nuovo</CreateButton>}
      headerButtonProps={{ size: "small" }}
      cardHeaderProps={{
        title: <Typography variant="h5">Sistemazioni</Typography>,
      }}
    >
      <TextField
        select
        value={filterValue}
        onChange={handleFilter} //va aggiunta una variabile di stato per cambiare value
        sx={{ width: 1 / 2, mb: 2 }}
        label={"Filtra per struttura"}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <DataGrid
        {...dataGridProps}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        autoHeight
      />
    </List>
  );
}
